import { For, Show, Signal, createEffect, createMemo, createSignal } from "solid-js";
import { FkInput as FKInput, DataStore, Flexbox, Image, Modal, requireDataStoreContext, Button, requireFocusContext, Select, requireViewContext, DataStoreContext } from "st-app";
import { roleDashboard as api } from 'sis-app/api'
import { OrgYearInfo } from "st-app/api";
import styles from '../sis-role-dashboard.module.css'
import ParentSelect from "../../sis-parent-select/sis-parent-select";

export interface IParentSelectionInfo {
    orgYear: OrgYearInfo | undefined;
    orgYearGU: string | undefined;
    parentGU: string | undefined;
}

type ParentSelectionProps = {
    hideFooter?: boolean;
    onClose: (res: IParentSelectionInfo) => void;
}

export function ParentSelectionModal(props: ParentSelectionProps) {
    const focus = requireFocusContext();
    const dataStore = requireDataStoreContext();
    const viewCtx = requireViewContext();

    const parentGU = createMemo(() => dataStore.get('currentValue', 'K12-ParentGuardianInfo-Parent-ParentGU'));

    const [orgYearGU, setOrgYearGU] = createSignal(focus.focusOrgYear()?.orgYearGU || '');
    const orgYear = createMemo(() => {
        const oygu = orgYearGU();
        return focus.orgYears.find(oy => oy.orgYearGU === oygu);
    });
    const orgYearName = createMemo(() => orgYear()?.organizationName ?? '');

    createEffect(() => {
        viewCtx.setServerState('ORG_YEAR_GU', orgYearGU());
    });

    const leafOrgs = createMemo(() => {
        return focus.orgYears.filter(oy => oy.isLeaf);
    });

    const nonLeafOrgs = createMemo(() => {
        const nlOrgsWithLeafs = focus.orgYears.reduce((res, it) => {
            if (it.parentOrganizationGU && it.isLeaf) {
                res[it.parentOrganizationGU] ??= 0;
                res[it.parentOrganizationGU]++;
            }
            return res;
        }, {} as Record<string, number>);

        return focus.orgYears.filter(oy => !oy.isLeaf && nlOrgsWithLeafs[oy.organizationGU ?? ''] > 0);
    });

    function accept() {
        props.onClose({
            orgYear: orgYear(),
            orgYearGU: orgYear()?.orgYearGU,
            parentGU: parentGU()
        });
    }

    return <DataStore context={dataStore} >
        <Flexbox dir="vertical" style="min-width: 600px" >
            <ParentSelect />
            <Show when={!props.hideFooter}>
                <Flexbox middle dir="horizontal" style="margin-top: 15px" >
                    <Flexbox.Item auto />
                    <Flexbox.Item>
                        <Button type="primary" enabled={!!parentGU()} onClick={accept}>Continue</Button>
                    </Flexbox.Item>
                </Flexbox>
            </Show>
        </Flexbox>
    </DataStore>
}
